/**
 * Settlement.jsx — 마케터 전용 정산서 (파인그룹)
 *
 * 구조:
 *   settlement/useSettlement.js   — 공통 훅 (companyCode='PINE')
 *   settlementdot/MobileView.jsx  — PC·모바일 통합 렌더 (PINE/DOT 공유)
 *
 * UI를 수정하면 DOT 정산서에도 자동으로 반영됩니다.
 */
import React from 'react';
import { useSettlement } from './settlement/useSettlement';
import { MobileView } from './settlementdot/MobileView';

export default function Settlement() {
  const state = useSettlement('PINE');
  return <MobileView {...state} />;
}
